/**
 * @file: isExtendedPropertyTypeSupported.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { ExtendedPropertyType } from '@euler/model';

const kSupportedExtendedPropertyTypes = new Set<ExtendedPropertyType>([
  'select',
  'text',
  'switch',
  'datetime',
  'assets',
]);

export const isExtendedPropertyTypeSupported = (type: ExtendedPropertyType) =>
  kSupportedExtendedPropertyTypes.has(type);
